import {ApplicationScope} from "../ApplicationScope";

export const uploadQuestionnaireQuestions = async (applicationScope: ApplicationScope): Promise<void> => {
  const result = await applicationScope.connectionPool.request()
    .query(`
    SELECT q.Text, COUNT(*) as answerCount
  FROM Question q join CompletedQuestionnaireAnswer qa on q.QuestionID = qa.QuestionID
  group by q.Text
  order by COUNT(*) desc
    `);

  applicationScope.logging.log({
    message: 'Questionnaire Data',
    questions: result.recordset
  })
};
export const uploadQuestionnaireAnswers = async (applicationScope: ApplicationScope): Promise<void> => {
  const result = await applicationScope.connectionPool.request()
    .query(`
    SELECT top 100 qa.TextAnswer, qa.NumberAnswer, qma.Text, COUNT(*) as answerCount
  FROM CompletedQuestionnaireAnswer qa left join QuestionMultiAnswer qma on qa.AnswerId = qma.AnswerId
  group by qa.TextAnswer, qa.NumberAnswer, qma.Text
  order by COUNT(*) desc
    `);

  applicationScope.logging.log({
    message: 'Questionnaire Data',
    questions: result.recordset
  })
};
